import styled from 'styled-components';
import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import { breakpoint, sizes } from 'variables';
import CategoryAccordionSidebar from './CategoryMenu/CategoryAccordionSidebar';
import SidebarFilters from './ProductListFilter/SidebarFilters/SidebarFilters';

/* #region styles */
const SideContainer = styled(Flex.Column)`
    display: none;

    ${breakpoint.up(sizes.lg)} {
        display: flex;
    }
`;
/* #endregion */

export default function ProductListSideContainer({ model }: { model: ProductListPartialViewModel }) {
    const { productList, showFiltersSide, showMenu } = model;
    const { menu, filters } = productList;

    const hasMenu = showMenu && !!menu;

    return (
        <SideContainer>
            {/* The default Category sidebar */}
            {showFiltersSide && <SidebarFilters model={filters} />}
            {/* The Category Accordion sidebar only appears on a few unique pages such as Dior, Chanel etc. */}
            {hasMenu && <CategoryAccordionSidebar model={menu} />}
        </SideContainer>
    );
}
